module.exports = __webpack_public_path__ + "static/media/fileIcon.bcecd5f1.svg";